<template>
  <div class="[ mk-orderindex ] row justify-content-center align-items-center mb-3">
    <div class="col col-sm-10 align-self-center">
      <div class="mt-5 mb-4 d-flex align-items-center justify-content-between my-4">
        <h1 class="text-green-primary mb-0">My Orders</h1>
        <div class="d-flex align-items-center">
          <el-input placeholder="Search" class="mr-2" v-model="query" clearable></el-input>
          <a href="/orders/create" class="btn-primary-rounded w-75">Create Order</a>
        </div>
      </div>

      <div class="card got-card">
        <div class="card-body got-order-card" v-loading="loading">
          <el-tabs v-model="activeName" class="got-order-tabs">
            <el-tab-pane label="Order Placed" name="placed">
              <order-list :tab="activeName" :query="query" v-if="activeName == 'placed'"></order-list>
            </el-tab-pane>

            <el-tab-pane label="Order Confirmed" name="confirmed">
              <order-list :tab="activeName" :query="query" v-if="activeName == 'confirmed'"></order-list>
            </el-tab-pane>

            <el-tab-pane label="Delivered" name="delivered">
              <order-list :tab="activeName" :query="query" v-if="activeName == 'delivered'"></order-list>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.got-order-tabs {
  .el-tabs__item {
    color: var(--got-black-500);
    font-size: 16px;
    font-weight: 700;

    &.is-active {
      color: var(--got-primary);
    }
  }

  .el-tabs__active-bar {
    height: 4px;
    background-color: var(--got-primary);
  }
}

.got-card {
  border: none;
  background-color: transparent;
}

.got-order-card {
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
}
</style>

<script>
import OrderList from "./components/OrderList.vue";
export default {
  components: { OrderList },
  data() {
    return {
      activeName: "placed",
      orders: [],
      loading: false,
      query: ''
    };
  },
  methods: {},
};
</script>
